import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { track } from "@/lib/track";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { Helmet } from "react-helmet-async";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import About from "@/pages/About";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import GrowGuides from "@/pages/GrowGuides";
import GrowGuideDetail from "@/pages/GrowGuideDetail";
import ResetPassword from "@/pages/ResetPassword";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import Shipping from "@/pages/Shipping";
import Returns from "@/pages/Returns";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";

function AppShell() {
  const location = useLocation();
  useEffect(() => {
    track("pageview", {}, location.pathname);
  }, [location.pathname]);
  // Synchronous check during render: detect Google OAuth callback
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      {process.env.REACT_APP_GOOGLE_SITE_VERIFICATION && (
        <Helmet>
          <meta name="google-site-verification" content={process.env.REACT_APP_GOOGLE_SITE_VERIFICATION} />
        </Helmet>
      )}
      <Nav />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/grow" element={<GrowGuides />} />
          <Route path="/grow/:slug" element={<GrowGuideDetail />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-cream min-h-screen">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <AppShell />
              <Toaster position="top-center" richColors />
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
